import $ from 'jquery';

$('.js-btn-link').on('click', function(event) {
    event.preventDefault();
    const $this = $(this);
    const target = $this.attr('target') || '_self';

    window.open($this.attr('href'), target);
});
